import { NgModule } from '@angular/core';

import { Section03Component } from './section03.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    Section03Component
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    Section03Component
  ]
})

export class Section03Module { }
